import { api } from "../api";
import { withoutActorIdentity } from "./actorIdentity";

export const searchLessee = async (memberId: String): Promise<any> => {
  const { data } = await api.post<any>(
    `/Lease/registration/lessee/`, {memberId: memberId}
  );
  return data;
};

export const getLeasedDogsByOwner = async (): Promise<any> => {
  const { data } = await api.get<object>(`/Lease/myleases`);

  return data;
};

export const getLeasedDog = async (dogId: string): Promise<any> => {
  const { data } = await api.get<object>(`/Lease/registration/dog/${dogId}`);

  return data;
};

export const validateLeaseDates = async (
  dogId: string,
  startDate: Temporal.PlainDate,
  endDate: Temporal.PlainDate
): Promise<any> => {
  const request = { dogId, startDate, endDate };
  const { data } = await api.post<object>(
    `/Lease/registration/validate`,
    request
  );

  return data;
};

export const submitLeaseRequest = async (req: any): Promise<any> => {
  const { data } = await api.post<object>(`/Lease/registration`, withoutActorIdentity(req));
  return data;
};

export default {
  getLeasedDogsByOwner,
  searchLessee,
  getLeasedDog,
  validateLeaseDates,
  submitLeaseRequest,
};
